// extracted by mini-css-extract-plugin
module.exports = {"site":"twoColumnLayout-module--site--3zRhs","siteInner":"twoColumnLayout-module--siteInner--ulk_j","siteContent":"twoColumnLayout-module--siteContent--5qjOw"};